import { TourStep } from "@app/core/types/tour.interface";

export type TablePosition = 'top' | 'bottom' | 'left' | 'right';

export interface TableTourStep extends TourStep {
  position?: TablePosition;
}

export interface TableTourConfig {
  name: string;
  steps: TableTourStep[];
}
